/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioVolumeS1Icon16Light } from './MediaAudioVolumeS1Icon16Light';
import { MediaAudioVolumeS1Icon16Regular } from './MediaAudioVolumeS1Icon16Regular';
import { MediaAudioVolumeS1Icon16Solid } from './MediaAudioVolumeS1Icon16Solid';
import { MediaAudioVolumeS1Icon20Light } from './MediaAudioVolumeS1Icon20Light';
import { MediaAudioVolumeS1Icon20Regular } from './MediaAudioVolumeS1Icon20Regular';
import { MediaAudioVolumeS1Icon20Solid } from './MediaAudioVolumeS1Icon20Solid';
import { MediaAudioVolumeS1Icon24Regular } from './MediaAudioVolumeS1Icon24Regular';
import { MediaAudioVolumeS1Icon24Solid } from './MediaAudioVolumeS1Icon24Solid';
import { MediaAudioVolumeS1Icon32Regular } from './MediaAudioVolumeS1Icon32Regular';
import { MediaAudioVolumeS1Icon64Regular } from './MediaAudioVolumeS1Icon64Regular';
var sizes = {
    16: {
        light: MediaAudioVolumeS1Icon16Light,
        regular: MediaAudioVolumeS1Icon16Regular,
        solid: MediaAudioVolumeS1Icon16Solid,
    },
    20: {
        light: MediaAudioVolumeS1Icon20Light,
        regular: MediaAudioVolumeS1Icon20Regular,
        solid: MediaAudioVolumeS1Icon20Solid,
    },
    24: {
        regular: MediaAudioVolumeS1Icon24Regular,
        solid: MediaAudioVolumeS1Icon24Solid,
    },
    32: {
        regular: MediaAudioVolumeS1Icon32Regular,
    },
    64: {
        regular: MediaAudioVolumeS1Icon64Regular,
    },
};
export var MediaAudioVolumeS1Icon = forwardRef('MediaAudioVolumeS1Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
